export default {
  agency: 'Sekretariat',
  lector: 'Lektor',
  copy: 'Kopiuj',
  addres_copied: 'Adres skopiowany',
  copied: 'Skopiowano',
  clipboardActiveEmail: 'Skopiowano adres e-mail do schowka',
  clipboardInactiveEmail: 'Kliknij, aby skopiować adres e-mail',
  clipboardInactive: 'Kliknij, aby skopiować',
};
